import { ReactNode } from 'react';
import Text from '../text/Text';
import styles from './StatefulCard.module.css';

type StatefulCardProps = {
  action: string;
  notification: ReactNode;
  name: string;
  imageSource: string;
};

const StatefulCard = ({
  action,
  notification,
  name,
  imageSource,
}: StatefulCardProps) => (
  <div>
    <div className={styles.actions}>
      <Text
        upperCase
        size='x-small'
        style={{ color: 'var(--color-text-gray)' }}
      >
        {action}
      </Text>
      <div>{notification}</div>
    </div>
    <div className={styles.content}>
      <Text size='m-small' weight='semi-bold'>
        {name}
      </Text>
      <div
        style={{
          width: '135px',
          height: '60px',
          background: `url(${imageSource})`,
        }}
      />
    </div>
  </div>
);

export default StatefulCard;
